export default function isOutsideReturnWindow(
  purchasedAt: string,
  returnWindowInDays: string | number
) {
  const timeSincePurchase = Date.now() - Date.parse(purchasedAt);
  const timeSincePurchaseInDays = Math.round(
    timeSincePurchase / (1000 * 60 * 60 * 24)
  );

  return parseInt(returnWindowInDays.toString(), 10) < timeSincePurchaseInDays;
}
